/* eslint-disable react/jsx-key */
/* eslint-disable no-undef */
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from '@mui/material';

const pages = [
  {
    to: '/',
    name: 'Trang chủ'
  },
  {
    to: '/new-map',
    name: 'Bản đồ'
  },
  {
    to: '/ke-hoach',
    name: 'Kế hoạch'
  },
  {
    to: '/du-lieu-quy-hoach',
    name: 'Quy hoạch'
  },
  // {
  //   to: '/danh-gia-quy-hoach',
  //   name: 'Đánh giá quy hoạch'
  // },
  {
    to: '/quy-hoach-khac',
    name: 'Quy hoạch khác'
  },
  {
    to: '/chien-luoc-thuy-loi',
    name: 'Chiến lược'
  },
  {
    to: '/contact',
    name: 'Liên hệ'
  },
];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function Header() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
      const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <div>
      <AppBar position={"fixed"}>
        <Container maxWidth="maxwithnav">
          <Toolbar disableGutters>
            <Avatar sx={{ width: isSmallScreen ?"30px" : "44px", height: isSmallScreen ?"50px" :'75px', marginRight:'10px' }}
              component={Link}
              to="/"
              alt="Remy Sharp" src={"image/logo.svg"} />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="#"
              sx={{
                display: { xs: 'none', maxwithnav1: 'flex'},
                fontWeight: 700,
                color: 'inherit',
                textDecoration: 'none',
                fontSize: isSmallScreen ? '12px' : '16px',
                lineHeight: '21.8px'
              }}
            >
              TRANG THÔNG TIN QUẢN LÝ KẾ HOẠCH - QUY HOẠCH THỦY LỢI
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                // transformOrigin={{
                //   vertical: 'top',
                //   horizontal: 'left',
                // }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                  justifyContent: { xs: 'flex-end', md: 'none' }
                }}
              >
                {pages.map(page => (
                  <Link to={page.to} key={page.to}>
                    <MenuItem key={page.to} onClick={handleCloseNavMenu} sx={{ textTransform: 'none' }}>
                      <Typography textAlign="center" sx={{ textTransform: 'none' }}>{page.name}</Typography>
                    </MenuItem>
                  </Link>
                ))}
              </Menu>
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              sx={{
                mr: 3,
                ml: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontWeight: 700,
                color: 'inherit',
                textDecoration: 'none',
                fontSize: '14px',
                lineHeight: '21.8px',
                textAlign: 'center'
              }}
            >
              TRANG THÔNG TIN QUẢN LÝ <br/> KẾ HOẠCH - QUY HOẠCH THỦY LỢI
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
              {pages.map((page) => (
                <Link to={page.to}>
                  <Button
                    key={page.to}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, fontWeight: 700, marginRight: '20px', display: 'block', textTransform: 'none', color: isActive(page.to) ? '#0B47A2' : '#FFFFFF', }}
                  >
                    {page.name}
                  </Button>
                </Link>
              ))}
            </Box>

            <Box sx={{ flexGrow: 0, marginLeft: '30px' }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" component={Link}
                    to="/"
                    src="image/image.png" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                // transformOrigin={{
                //   vertical: 'top',
                //   horizontal: 'right',
                // }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

export default Header;
